var Request = require("../helper/request");
var Detail = require("./advertisement/detail");
var Extension = require("./advertisement/extension");
var Setting = require("./advertisement/setting/setting");

function Advertisement(app, companyId){
	var self = this;
	self.app = app;
	self.companyId = companyId
	self.request = new Request(app);

	self.routes = {
		index: {
			url: "/company/"+self.companyId+"/advertisement",
			method: "GET"
		},
		show: {
			url: "/company/"+self.companyId+"/advertisement/:id",
			method: "GET"
		},
		create: {
			url: "/company/"+self.companyId+"/advertisement",
			method: "POST"
		},
		update: {
			url: "/company/"+self.companyId+"/advertisement/:id",
			method: "PUT"
		},
		delete: {
			url: "/company/"+self.companyId+"/advertisement/:id"
		}
	};
}

Advertisement.prototype.index = function(){
	var self = this;
	return self.request.get(self.routes.index.url);
}

Advertisement.prototype.show = function(id){
	var self = this;
	var uri = self.routes.show.url.replace(":id", id);
	return self.request.get(uri);
}

Advertisement.prototype.create = function(data){
	var self = this;
	return self.request.post(self.routes.create.url, {
		advertisement: data
	});
}

Advertisement.prototype.update = function(id, data){
	var self = this;
	var uri = self.routes.update.url.replace(":id", id);
	return self.request.put(uri, {
		advertisement: data
	});
}

Advertisement.prototype.delete = function(id){
	var self = this;
	var uri = self.routes.delete.url.replace(":id", id);
	return self.request.delete(uri);
}

Advertisement.prototype.setting = function(){
	var self = this;
	return new Setting(self.app, self.companyId);
}

Advertisement.prototype.detail = function(advertisementId){
	var self = this;
	return new Detail(self.app, self.companyId, advertisementId);
}

Advertisement.prototype.extension = function(advertisementId){
	var self = this;
	return new Extension(self.app, self.companyId, advertisementId);
}

module.exports = Advertisement;